<template>
  <div>
    <PendingBillingCases></PendingBillingCases>
  </div>
</template>
  
  <script>
const PendingBillingCases = defineAsyncComponent(() =>
  import("@/components/cases/AllBilledCases")
);
import { defineAsyncComponent } from "vue";
export default {
  components: {
    PendingBillingCases,
  },
};
</script>
  